<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-title>Credit Card Transaction</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen>
  <div class="gateway-transaction">
    <div *ngIf="view === 'in_progress'">
      <img src="assets/image/payments/gateway-in-progress.png">
      <h1>Payment request in progress...</h1>
      <p *ngIf="!isManualCardEntry">Please instruct the
        guest to follow the prompts on the terminal.</p>

      <!-- Display cancel button for stripe payments only -->
      <ng-container *ngIf="(creditCardProcessingType$ | async) === 'Stripe'">
        <div>
          <ion-button color="danger"
                      debounce-click
                      [debounceTime]="0"
                      (debounceClick)="onCancelTransaction()">Cancel Transaction</ion-button>
        </div>
      </ng-container>
    </div>
    <div *ngIf="view === 'success'">
      <img src="assets/image/payments/gateway-complete.svg">
      <h1>Payment Approved</h1>
      <p>Please ensure the guest has removed their card from the terminal and provide them their receipt.</p>
      <div>
        <ion-button debounce-click
                    [debounceTime]="0"
                    (debounceClick)="modalCtrl.dismiss()"
                    color="dark">Close</ion-button>
      </div>
    </div>
    <div *ngIf="view === 'error'">
      <img src="assets/image/payments/gateway-error.png">
      <h1>Payment Not Completed</h1>

      <ng-container *ngIf="gatewayError">
        <p *ngIf="gatewayError.cmdStatus as cmdStatus" class="ion-text-center">
          CMD Status: {{cmdStatus}}
        </p>
        <p *ngIf="gatewayError.message as textResponse" class="ion-text-center">
          Text Response: {{ textResponse }}
        </p>
      </ng-container>

      <div>
        <ion-button debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onRetry()"
                    color="dark">Try Again</ion-button>
        <ion-button debounce-click
                    [debounceTime]="0"
                    (debounceClick)="modalCtrl.dismiss()"
                    color="danger">Cancel</ion-button>
      </div>
    </div>
  </div>
</ion-content>